import { render, staticRenderFns } from "./ForestCompactHeader.vue?vue&type=template&id=42af2b04&scoped=true&"
import script from "./ForestCompactHeader.vue?vue&type=script&lang=ts&"
export * from "./ForestCompactHeader.vue?vue&type=script&lang=ts&"
import style0 from "./ForestCompactHeader.vue?vue&type=style&index=0&id=42af2b04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42af2b04",
  null
  
)

export default component.exports